__turbopack_context__.v({
  "PageNavigation": "gbkyKa_PageNavigation",
  "PageNavigation--Expanded": "gbkyKa_PageNavigation--Expanded",
  "PageNavigation__Button": "gbkyKa_PageNavigation__Button",
  "PageNavigation__ButtonTag": "gbkyKa_PageNavigation__ButtonTag",
  "PageNavigation__ButtonText": "gbkyKa_PageNavigation__ButtonText",
  "PageNavigation__Chevron": "gbkyKa_PageNavigation__Chevron",
  "PageNavigation__Icon": "gbkyKa_PageNavigation__Icon",
  "PageNavigation__Item": "gbkyKa_PageNavigation__Item",
  "PageNavigation__Link": "gbkyKa_PageNavigation__Link",
  "PageNavigation__Link--Active": "gbkyKa_PageNavigation__Link--Active",
  "PageNavigation__Navigation": "gbkyKa_PageNavigation__Navigation",
});
